module.exports = __webpack_public_path__ + "img/phase.e8d33407.png";